import React from "react";
import { useParams } from "react-router-dom";
import { useGetSingleUserPermissions } from "../../../../hooks/useGetSingleUserPermissions";
import { useTranslation } from "react-i18next";
import Skeletons from "../../../../components/loader/Skeletons";
import SimpleAlert from "../../../../components/display/SimpleAlert";
import DetailCard from "../../../../components/display/DetailCard";
import { capitalizeFirstLetter } from "../../../../utils/Functions";
import PageContentWrapper from "../../../../components/wrappers/PageContentWrapper";

export default function UserLocationDisplay() {
  const { id } = useParams();
  const { data, loading, error } = useGetSingleUserPermissions(id);
  const { t } = useTranslation();
  function UserInformationRow({ location }) {
    if (location == null || location == undefined) {
      return null;
    }

    const order = [
      "Country",
      "City",
      "Place",
      "Province",
      "Address",
      "Addressnumber",
      "Zipcode",
    ];

    const entries = Object.entries(location)
      .filter(
        ([key, value]) =>
          order.includes(capitalizeFirstLetter(key)) &&
          value != null &&
          value != "" &&
          typeof value != "object"
      )
      .map(([key, value]) => ({
        title: capitalizeFirstLetter(key),
        value: t(String(value)),
      }));

    // Sort based on order array
    const values = entries.sort((a, b) => {
      const indexA = order.indexOf(a.title);
      const indexB = order.indexOf(b.title);
      return indexA - indexB;
    });

    if (values.length == 0) {
      return null;
    }

    return <DetailCard valueArray={values} grid elevation={4} gridCount={3} />;
  }

  if (loading) {
    return (
      <PageContentWrapper>
        <Skeletons numOfSkeletons={6} />
      </PageContentWrapper>
    );
  } else if (error) {
    return (
      <SimpleAlert
        severity={"error"}
        message={"CouldntFetchUserInformationAtThisTime"}
      />
    );
  }

  return (
    <UserInformationRow
      location={data?.user?.userDetails?.location}
      key={"general-information-paper-view"}
    />
  );
}
